import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { screenSizes, useScreenSize } from './useScreenSize';

export const useSidebar = () => {
  const screenSize = useScreenSize();
  const [isOpen, setIsOpen] = useState<boolean | undefined>();
  const [forceOpen, setForceOpen] = useState<boolean | undefined>();
  const { pathname } = useLocation();

  /* istanbul ignore next -- @preserve */
  useEffect(() => {
    if (!screenSize) return;

    if (screenSizes.indexOf(screenSize) > 3) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [screenSize, pathname]);

  return {
    isOpen: forceOpen === undefined ? isOpen : forceOpen,
    setIsOpen: setForceOpen,
  };
};
